export default "/images/vendor/flag-icon-css/flags/1x1/co.svg?4c87d079860a09479706816fb964cfdc";